import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setToken(params.get("token") || ""); }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display font-extrabold text-xl mb-10 inline-block">BeatCredsi<span className="text-amber-500 text-sm align-super">™</span></Link>
        <div className="text-overline mb-4">Set New Password</div>
        <h1 className="font-display text-3xl font-medium tracking-tight mb-8">Reset your password.</h1>

        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <label className="text-xs text-neutral-400 uppercase tracking-widest mb-2 block">Reset Token</label>
            <input data-testid="reset-token-input" required value={token} onChange={(e) => setToken(e.target.value)}
              className="w-full bg-[#161616] border border-white/20 px-4 py-3 text-white outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500/40 font-mono-tech text-xs" />
          </div>
          <div>
            <label className="text-xs text-neutral-400 uppercase tracking-widest mb-2 block">New Password (min 8)</label>
            <input data-testid="reset-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#161616] border border-white/20 px-4 py-3 text-white outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500/40" />
          </div>
          {error && <div data-testid="reset-error" className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/20 px-3 py-2">{error}</div>}
          {done && <div data-testid="reset-success" className="text-sm text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 px-3 py-2">Password reset. Redirecting to login…</div>}
          <button data-testid="reset-submit-btn" type="submit" disabled={busy || done}
            className="w-full bg-amber-500 text-black font-semibold py-3 hover:brightness-110 disabled:opacity-50">
            {busy ? "Resetting…" : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
